import Upload from "Components/shared/upload/upload";
import React, { useEffect, useState } from "react";
import { isEmpty, isNil, omitBy } from "lodash";
import { toaster } from "Helpers/toaster";
import { Col, Row } from "antd";
import { SelectInput } from "@life-line-lab/components-react";
import { useTranslation } from "react-i18next";
import { QuestionCircleOutlined } from "@ant-design/icons";

const UploadOrders = (props: any) => {
  const { handleConfirm, onFilter, isFileCleared, setIsFileCleared } = props || {};
  const { t } = useTranslation();

  //   Json States
  // ====================================================
  const [jsonFile, setJsonFile] = useState<any>([]);

  useEffect(() => {
    if (isFileCleared) {
      setJsonFile && setJsonFile([]);
    }
  }, [isFileCleared]);

  //   Functions
  // ====================================================
  // when a file is uploaded, this is triggered
  const handleFileUpload = ({ fileList: fileList }) => {
    setIsFileCleared && setIsFileCleared(false);
    setJsonFile && setJsonFile(fileList);
  };

  //   Submitting Files
  // ====================================================
  // on submitting, this extracts the file from the object
  // in antd, originFileObj is where the content is stored
  const handleFileFormat = () => {
    if (isEmpty(jsonFile)) {
      toaster("error", "Please upload a file.");
      return;
    }

    // only one file is uploaded
    const file = jsonFile[0].originFileObj;
    handleConfirm(file);
  };

  return (
    <div className="om-po-container">
      <div className="om-po-section">
        <div className="om-po-title">{t("label.planScheduleUploadResult")}</div>
        <div className="om-info om-help">
          <QuestionCircleOutlined style={{ fontSize: "16px" }} />
          <div>{t("txt.onlyScheduleUploadResult")}</div>
        </div>
        <Upload
          onConfirm={() => handleFileFormat()}
          onCancel={() => setJsonFile([])}
          onRemove={() => setJsonFile([])}
          onChange={handleFileUpload}
          fileList={jsonFile}
          fileFormat={".json"}
          uploadText={
            <div>
              <p className="ant-upload-text">Click or drag file to this area to upload</p>
              <p className="ant-upload-hint">Format: .json only</p>
            </div>
          }
        />
      </div>
    </div>
  );
};

export default UploadOrders;
